import React from 'react';

const DriveBySection = () => {
  const features = [
    {
      number: "01",
      title: "Real-Time Car Spotting",
      description: "Browse nearby rides as they cruise through your city."
    },
    {
      number: "02",
      title: "Share Your Drive",
      description: "Post your ride and connect with enthusiasts in real-time."
    },
    {
      number: "03",
      title: "Discover Rides",
      description: "Explore the car culture in your area and beyond."
    },
    {
      number: "04",
      title: "Connect On The Go",
      description: "Join the community and experience car culture in motion."
    }
  ];

  return (
    <section className="relative overflow-hidden sm:mt-14  xs:-mt-96 xxs:mt-1   mt-5">
      {/* bg-[#0B0B0B] text-white pb-12 md:pb-16 lg:pb-24 pt-0 px-4 md:px-8 lg:px-16 xl:px-24  */}
      {/* Background decorative elements - stars/glints */}
      {/* <div className="absolute top-0 left-0 w-32 h-32 opacity-20 pointer-events-none">
        <div className="absolute top-8 left-8 w-2 h-2 bg-white rounded-full"></div>
        <div className="absolute top-12 left-16 w-1 h-1 bg-white rounded-full"></div>
        <div className="absolute top-16 left-12 w-1.5 h-1.5 bg-white rounded-full"></div>
      </div>
      <div className="absolute bottom-0 right-0 w-32 h-32 opacity-20 pointer-events-none">
        <div className="absolute bottom-8 right-8 w-2 h-2 bg-white rounded-full"></div>
        <div className="absolute bottom-12 right-16 w-1 h-1 bg-white rounded-full"></div>
        <div className="absolute bottom-16 right-12 w-1.5 h-1.5 bg-white rounded-full"></div>
      </div> */}

      {/* Main Container */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12   xl:gap-28">
          
          {/* Left Section: Drive By Image */}
          <div className="w-full flex items-center justify-start lg:justify-end">
            <div className="relative w-full max-w-none md:max-w-[720px]  lg:max-h-[820px] rounded-3xl md:ml-12 lg:-ml-16 xl:-ml-24 2xl:-ml-16">
              <img
                src="/asset/drivebg.png"
                alt="Drive By Highlight"
                className="w-full h-auto object-contain rounded-3xl 2xl:scale-[1.28] 2xl:origin-left 2xl:-translate-x-44"
                loading="lazy"
              />
              {/* <style>{`
                .drivebox-img {
                  width: 105%;
                  transform: scaleX(1.12);
                  margin-right: 0%;
                }
                @media (min-width: 1024px) {
                  .drivebox-img {
                    width: 120%;
                    transform: scaleX(1.18);
                    margin-right: 5%;
                  }
                }
                @media (min-width: 1280px) {
                  .drivebox-img {
                    width: 103%;
                    transform: scaleX(1.24);
                    margin-right: 10%;
                  }
                    @media  (min-width: 1436px) and (max-width: 1535px) {
                  .drivebox-img {
                    width: 10%;
                    transform: scaleX(1.24);
                    margin-right: 10%;
                  }
                    @media  (min-width: 1536px) {
                      .drivebox-img {
                        width: 110%;
                        transform: scaleX(1.24);
                        margin-right: 10%;
                      }
                    }
                }
                }
                .drive-img {
                  width: 72%;
                  height: auto;
                  max-height: 260px;
                }
                @media (min-width: 640px) {
                  .drive-img {
                    width: 80%;
                    height: auto;
                    max-height: 390px;
                    top: 61% !important;
                  }
                }
                @media (min-width: 768px) {
                  .drive-img {
                    width: 78%;
                    height: auto;
                    max-height: 420px;
                  }
                }
                @media (min-width: 1024px) {
                  .drive-img {
                    width: 88%;
                    height: auto;
                    max-height: 320px;

                
                  }
                }
                @media (min-width: 1280px) {
                  .drive-img {
                    width: 140%;
                    height: auto;
                    max-height: 420px;
                    top: 61% !important;
                  }
                }
              `}</style> */}
              {/* Text inside the box */}
              {/* <div 
                className="absolute text-xl sm:text-2xl md:text-4xl lg:text-2xl xl:text-3xl  sm:mt-10 md:mt-4 xl:-mt-4 font-semibold text-white uppercase tracking-wider font-noto-sans leading-relaxed whitespace-nowrap"
                style={{
                  top: '6%',
                  left: '50%',
                  transform: 'translate(-50%, -50%) scaleY(1.4)',
                  zIndex: 15,
                  pointerEvents: 'none',
                }}
              >
                Explore the Driveby Feed
              </div> */}
              {/* Drive image inside the box */}
              {/* <img 
                src="/asset/drive.png" 
                alt="Drive By" 
                className="absolute h-auto object-contain z-0 drive-img"
                style={{
                  top: '64%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                }}
              /> */}
            </div>
          </div>

          {/* Right Section: Drive By Features */}
          <div className="w-full flex flex-col justify-center">
            <div className="mb-8 sm:mt-10 lg:mb-5 xl:mt-8 2xl:mt-6">
              <div className="mb-4 md:mb-6 xl:mt-10">
                <h3 className="text-2xl md:text-3xl lg:text-2xl xl:text-3xl font-semibold text-white uppercase tracking-wider font-noto-sans leading-tight mb-2 xl:mb-2 md:mb-2 2xl:-ml-3 text-left xl:whitespace-nowrap" style={{ transform: 'scaleY(1.3)' }}>
                  <span>DRIVE BY – SEE EVERY </span>
                  <span className="text-orange-700">RIDE IN ACTION</span>
                </h3>
              </div>
              <p className="text-gray-200 text-base md:text-lg lg:text-lg font-noto-sans leading-relaxed max-w-2xl xl:-ml-4 mb-1 md:mb-1 xl:mb-0">
              {/* <span className="xl:whitespace-nowrap">  */}
                Experience the thrill of car culture in motion. Discover rides, share yours, and connect
                {/* </span> */}
              {/* <br className="hidden xl:block" /> */}
               with enthusiasts on the go.
              </p>
            </div>
            
            <div className="space-y-4 md:space-y-6 lg:space-y-2   xl:-ml-4">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex items-start w-full gap-3 md:gap-4 lg:gap-5 pb-1 md:pb-4"
                  style={
                    index < features.length - 1
                      ? {
                          borderBottom: '1px solid #FFFFFF0D',
                          marginRight: '-56px',
                          paddingRight: '56px'
                        }
                      : {}
                  }
                >
                  <div className="flex-shrink-0 mt-1">
                    <div className="w-6 h-6 md:w-8 md:h-8 lg:w-8 lg:h-8 rounded flex items-center justify-center aspect-square" style={{ backgroundColor: '#141415', border: '1px solid #FFFFFF0D' }}>
                      <span className="text-white font-bold text-[11px] md:text-xs lg:text-xs font-oswald">
                        {feature.number}
                      </span>
                    </div>
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-white text-base md:text-lg lg:text-base font-regular mb-2 md:mb-3 font-noto-sans leading-tight break-words">
                      {feature.title}
                    </h3>
                    <p className="text-gray-200 text-xs md:text-sm lg:text-base font-regular leading-relaxed font-noto-sans whitespace-normal break-words">
                      {feature.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DriveBySection;

